import { Input } from 'components/elements';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function VisaDocumentInformationForm() {
  const { t } = useTranslation();

  // MULTIPRICE DOCUMENT TYPE
  // const { editable } = useFormState();
  // const name = 'visaDocumentItems' as const;
  // const { fields, append, remove } = useFieldArray({
  //   control,
  //   name,
  //   keyName: 'customId',
  // });

  // const onAdd = React.useCallback(() => {
  //   append({
  //     id: undefined,
  //     preferenceId: undefined,
  //     price: undefined,
  //   } as any);
  // }, [append]);

  // const onRemove = React.useCallback(
  //   (index: number) => () => {
  //     remove(index);
  //   },
  //   [remove],
  // );

  return (
    <FullContainer
      style={{
        overflow: 'auto',
        maxHeight: 'calc(100dvh - 250px)',
      }}
    >
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="name"
            label={t('common:name')}
            placeholder={t('common:name')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="description"
            label={t('common:description')}
            placeholder={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>

      <SectionContainer>
        {/* <HalfContainer>
          <PreferenceSelectInput
            label={t('common:document_type')}
            name="preferenceId"
            subType={PreferenceGroupSubTypeEnum.Visa}
            type="booking"
            placeholder=""
          />
        </HalfContainer>
        <Separator gap={16} /> */}
        <HalfContainer>
          <Input
            type="number"
            name="price"
            label={t('common:default_price')}
            placeholder=""
            required
          />
        </HalfContainer>
      </SectionContainer>

      {/* MULTIPRICE DOCUMENT TYPE FIELDS */}
      {/* <Text variant="HeadingXSmall">{t('common:travel_document_price')}</Text>
      <Separator gap={16} />
      {fields.map((field, index) => {
        const firstRow = index === 0;
        const parentName = `${name}.${index}` as const;
        return (
          <SectionContainer
            key={field.customId}
            $style={{
              justifyContent: editable ? 'start' : 'space-between',
            }}
          >
            <HalfContainer>
              <PreferenceSelectInput
                label={firstRow ? t('common:document_type') : ''}
                name={`${parentName}.preference`}
                subType={PreferenceGroupSubTypeEnum.Visa}
                type="booking"
                placeholder=""
              />
            </HalfContainer>
            <Separator gap={16} />
            <HalfContainer>
              <Input
                type="number"
                name={`${parentName}.price`}
                label={firstRow ? t('common:price') : ''}
                placeholder=""
              />
            </HalfContainer>
            {!firstRow && editable && (
              <IconButton
                buttonType="tertiary"
                overrides={{
                  Root: {
                    style: {
                      height: '100%',
                      ':hover': {
                        backgroundColor: stylesColors.redLightest,
                      },
                    },
                  },
                }}
                onClick={onRemove(index)}
              >
                <TrashSVG color={stylesColors.redDefault} />
              </IconButton>
            )}
          </SectionContainer>
        );
      })}
      {editable && (
        <Button
          onClick={onAdd}
          startEnhancer={(color, size) => (
            <PlusCircleSVG size={size} color={color} />
          )}
        >
          {t('common:add')}
        </Button>
      )} */}
    </FullContainer>
  );
}
